export default "__VITE_ASSET__bc7ca01b__"